import { getUtm } from '~/utils/routeUtm';
import * as scheme from './scheme/kids.gql';

export default class {
  constructor(apolloClient, app) {
    this.apolloClient = apolloClient;
    this.app = app;
  }

  query(...args) {
    return this.apolloClient.query.apply(this, args);
  }

  mutate(...args) {
    return this.apolloClient.mutate.apply(this, args);
  }

  registerForOlympiad({
    ageGroup,
    birthdate,
    childName,
    childPatronymic,
    childSecondName,
    classNumber,
    email,
    landerCode,
    name,
    password,
    patronymic,
    phone,
    phoneStatus,
    secondName,
  }) {
    const utmData = getUtm(this.app?.context?.route);

    return this.mutate({
      mutation: scheme.REGISTER_FOR_OLYMPIAD,
      variables: {
        ageGroup,
        birthdate,
        childName,
        childPatronymic,
        childSecondName,
        classNumber,
        email,
        emailMe: true,
        landerCode,
        name,
        onlyRegistration: false,
        password,
        patronymic,
        phone,
        phoneStatus,
        recommendedContactMethod: 'phone',
        secondName,
        sendLead: true,
        utmData,
      },
    })
      .then(({ data }) => data?.registerForOlympiad || {});
  }

  getPublishedOlympiadPacks() {
    return this.query({
      query: scheme.GET_PUBLISHED_OLYMPIAD_PACKS,
    })
      .then(({ data }) => data?.getPublishedOlympiadPacks || []);
  }

  getOlympiadPackById(id) {
    return this.query({
      query: scheme.GET_OLYMPIAD_PACK_BY_ID,
      variables: { id },
    })
      .then(({ data }) => data?.getOlympiadPackById || {});
  }

  getOlympiadById(id) {
    return this.query({
      query: scheme.GET_OLYMPIAD_BY_ID,
      variables: { id },
    })
      .then(({ data }) => data?.getOlympiadById || {});
  }

  login(email, password) {
    return this.mutate({
      mutation: scheme.LOGIN,
      variables: {
        email,
        password,
        remember: false,
      },
    }).then((resposne) => resposne.data.signIn);
  }

  //  Восстановление пароля
  remember(email) {
    return this.mutate({
      mutation: scheme.FORGOT_PASSWORD,
      variables: {
        email,
      },
    }).then((response) => response.data?.forgotPassword || {});
  }

  selfSignUp(email, name, phone) {
    return this.mutate({
      mutation: scheme.REGISTER_SELF,
      variables: {
        email,
        name,
        phone,
        recommendedContactMethod: 'phone',
        utmData: '{}',
        landerCode: 'school',
      },
    }).then((resposne) => resposne.data?.selfSignUp);
  }
}
